import { render, staticRenderFns } from "./CaseHome.vue?vue&type=template&id=1990ba5a&scoped=true"
import script from "./CaseHome.vue?vue&type=script&lang=js"
export * from "./CaseHome.vue?vue&type=script&lang=js"
import style0 from "./CaseHome.vue?vue&type=style&index=0&id=1990ba5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990ba5a",
  null
  
)

export default component.exports